import { MyPortfolioContainer } from '@/features/isolated-portfolio/MyPortfolioContainer'

export function IsolatedDashboard() {
  return <MyPortfolioContainer />
}
